import { Routes, RouterModule } from '@angular/router';
import { HeaderComponent } from './header/header.component';
import { LoginComponent } from './login/login.component';
import { LoginBBMMComponent } from './login-bbmm/loginbbmm.component';
import { LogoutComponent } from './logout/logout.component';
import { SSOComponent } from './login/sso.component';
import { UserNotFoundComponent } from './login/usernotfound.component';
import { PageNotFoundComponent } from './login/pagenotfound.component';
import { DMDonViXuLyComponent } from './dm-don-vi-xu-ly/dm-don-vi-xu-ly.component';
import { HomeComponent } from './home/home.component';
import { ChiTietYeuCau } from './home/chi-tiet-yeu-cau.component';
import { CapDonViComponent } from './cap-don-vi/cap-don-vi.component';
import { HinhThucGuiComponent } from './hinh-thuc-gui/hinh-thuc-gui.component';
import { ChangePasswordComponent } from './account/change-password.component';
import { AspNetRolesComponent } from './asp-net-roles/asp-net-roles.component';
import { AuthService } from './services/auth.service';
import { AllAuthGuard } from './services/all-auth.service';
import { VnptHttpService } from './services/vnpt-http.service';
import { VnptMenuComponent } from './directives/vnpt-menu.component';
import { VnptQuickLink } from './directives/vnpt-quicklink.directive';
import { GoogleChart } from './directives/google-chart';
import { VnptQuyenDirective } from './directives/vnpt-quyen.directive';
import { VnptBuidOptionsDirective } from './directives/vnpt-buid-options.directive';
import { TaiKhoanComponent } from './thong-tin-tai-khoan/tai-khoan.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { QuyTrinhXuLyComponent } from './quy-trinh-xu-ly/quy-trinh-xu-ly.component';
import { QuyTrinhXuLyThietBiComponent } from './quy-trinh-xu-ly-thiet-bi/quy-trinh-xu-ly-thiet-bi.component';
import { SYSHdsdComponent } from './sys-hdsd/sys-hdsd.component';
import { LichSuDangNhapComponent } from './he-thong/lich-su-dang-nhap/lich-su-dang-nhap.component';
import { XLXuLyLichSuHomeComponent } from './home/xl-xu-ly-lich-su.component';
import { NotificationService } from './services/notification.service';
import { DataService } from './services/data.service';
import { UtilityService } from './services/utility.service';
import { SignalRService } from './services/signalR.service';
import { ChatEventService } from './services/chat-event.service';

//import { PdfViewerComponent } from 'ng2-pdf-viewer';

export const ROUTES: Routes = [
  // { path: 'login', component: LoginComponent },
  { path: 'login', component: LoginBBMMComponent },
  { path: 'logout', component: LogoutComponent },
  { path: 'sso/:token/:id_token', component: SSOComponent },
  { path: 'usernotfound', component: UserNotFoundComponent },
  { path: '', redirectTo: 'home', pathMatch: 'full' },  
  { path: 'home', component: HomeComponent, canActivate:[AllAuthGuard] },
  { path: 'chi-tiet-yeu-cau', component: ChiTietYeuCau, canActivate:[AllAuthGuard] },
  { path: 'dm-don-vi-xu-ly', component: DMDonViXuLyComponent, canActivate:[AllAuthGuard] },
  { path: 'dm-nhom-quyen', component: AspNetRolesComponent },
  { path: 'dm-cap-don-vi', component: CapDonViComponent, canActivate:[AllAuthGuard] },
  { path: 'dm-hinh-thuc-gui', component: HinhThucGuiComponent, canActivate:[AllAuthGuard] },
  { path: 'change-password', component: ChangePasswordComponent },
  //danh mục sự cố
  
  { path: 'tai-khoan', component: TaiKhoanComponent},
  { path: 'quen-mat-khau', component: ForgotPasswordComponent },
  { path: 'reset-password', component: ResetPasswordComponent },
  { path: 'quy-trinh-xu-ly', component: QuyTrinhXuLyComponent,canActivate:[AllAuthGuard] },
  { path: 'quy-trinh-xu-ly/:keyword/:loaiQT', component: QuyTrinhXuLyComponent,canActivate:[AllAuthGuard] },
  { path: 'quy-trinh-xu-ly-thiet-bi', component: QuyTrinhXuLyThietBiComponent,canActivate:[AllAuthGuard] },
  { path: 'quy-trinh-xu-ly-thiet-bi/:keyword/:idloaithietbi/:idhangsanxuat/:iddongthietbi/:idtrangthai', component: QuyTrinhXuLyThietBiComponent,canActivate:[AllAuthGuard] },
  { path: 'sys-hdsd', component: SYSHdsdComponent },
  { path: 'lich-su-ca-nhan', component: LichSuDangNhapComponent },  
  {
    path: 'quanly-canhbao',
    loadChildren: 'app/quanly-canhbao/quanly-canhbao.module#QuanlyCanhbaoModule'
  },  
  // { path: 'quanly-canhbao', component: QuanlyCanhbaoComponent },

  { path: 'he-thong', loadChildren: "app/he-thong/he-thong.module#HeThongModule" },
  { path: 'danh-muc', loadChildren: "app/danhmuc/danh-muc.module#DanhMucModule" },
  { path: 'san-pham', loadChildren: "app/sanpham/san-pham.module#SanPhamModule" },
  { path: 'thiet-bi', loadChildren: "app/thiet-bi/thiet-bi.module#ThietBiModule" },
  { path: 'xu-ly', loadChildren: "app/xu-ly/xu-ly.module#XuLyModule" },
  { path: 'xl-xu-ly-su-co', loadChildren: "app/xu-ly/xl-xu-ly-su-co/xu-ly-su-co.module#XuLySuCoModule"},
  { path: 'phan-anh', loadChildren: "app/phan-anh/phan-anh.module#PhanAnhModule"},
  { path: 'xl-xac-nhan-xu-ly', loadChildren: "app/xu-ly/xl-xac-nhan-xu-ly/xl-xac-nhan-xu-ly.module#XLXacNhanXuLyModule"},
  { path: 'dm-doi-tuong', loadChildren: "app/danhmuc/dm-doi-tuong/dm-doi-tuong.module#DmDoiTuongModule" },
  { path: 'thong-ke', loadChildren: "app/thong-ke/thong-ke.module#ThongKeModule" },
  { path: 'dieu-hanh', loadChildren: "app/dieu-hanh/dieu-hanh.module#DieuHanhXuLyModule" },
  { path: 'nang-cao', loadChildren: "app/nang-cao/nang-cao.module#NangCaoModule" }, 
  { path: 'tien-ich', loadChildren: "app/tien-ich/tien-ich.module#TienIchModule" }, 
  { path: 'xphc', loadChildren: "app/xu-phat-hanh-chinh/xu-phat-hanh-chinh.module#XuPhatHanhChinhModule" }, 
  { path: 'hkg', loadChildren: "app/hop-khong-giay/hop-khong-giay.module#HopKhongGiayModule" },
  { path: 'print-chart', loadChildren: "app/shared/print-chart/print-chart.module#PrintChartModule" },

  { path: 'sbspo', loadChildren: "app/login/bypass-sso/bypass-sso.module#BypassSsoModule" },

  { path: 'chat', loadChildren: "app/chat/chat.module#ChatModule" },

  { path: 'page-not-found', component: PageNotFoundComponent },
  { path: '**', redirectTo: 'page-not-found', pathMatch: 'full' },  
]
export const DECLARE_COMPONENTS = [
  VnptMenuComponent,
  VnptQuickLink,
  VnptQuyenDirective,
  VnptBuidOptionsDirective,

  //PdfViewerComponent,
  
  LoginComponent,
  LoginBBMMComponent,
  LogoutComponent,
  HeaderComponent,
  HomeComponent,
  ChiTietYeuCau,
  DMDonViXuLyComponent,
  CapDonViComponent,
  CapDonViComponent,
  HinhThucGuiComponent,
  CapDonViComponent,
  AspNetRolesComponent,
  ChangePasswordComponent,
  TaiKhoanComponent,
  LichSuDangNhapComponent,
  ForgotPasswordComponent,
  ResetPasswordComponent,
  QuyTrinhXuLyComponent,
  QuyTrinhXuLyThietBiComponent,
  SSOComponent,
  UserNotFoundComponent,
  PageNotFoundComponent,
  GoogleChart,
  SYSHdsdComponent,
  XLXuLyLichSuHomeComponent
]
export const DECLARE_SERVICES = [
  //shared
  AllAuthGuard,
  AuthService,
  SignalRService,
  ChatEventService,
  VnptHttpService,
  NotificationService,
  UtilityService,
  DataService
];



// WEBPACK FOOTER //
// D:/1.eGovD/CITIZEN/sources/citizen-admin/Angular/src/app/app.routes.ts